import HomeSectionHead from "./HomeSectionHead";
import { customerLogos, homePartnerLogos } from "../data/constants";

const baseUrl = process.env.PUBLIC_URL || "";

const customerRowOne = customerLogos.filter((_, i) => i % 2 === 0);
const customerRowTwo = customerLogos.filter((_, i) => i % 2 !== 0);
const partnerRowOne = homePartnerLogos.filter((_, i) => i % 2 === 0);
const partnerRowTwo = homePartnerLogos.filter((_, i) => i % 2 !== 0);

export function HomeCustomersSection() {
  return (
    <section className="home-section home-section--wide home-section--surface animate-on-scroll">
      <div className="container">
        <HomeSectionHead
          label="Our Customers"
          title="Trusted by Leading Organizations"
          desc="Our customers are at the heart of everything we do. We're committed to outstanding service, clear guidance, and solutions tailored to your needs."
        />
        <div className="home-logo-marquee-wrap">
          <div className="logo-marquee logo-marquee-customers">
            {[
              { items: customerRowOne, dirClass: "is-ltr" },
              { items: customerRowTwo, dirClass: "is-rtl" },
            ].map((row, rowIdx) => (
              <div key={`customer-row-${rowIdx}`} className="logo-marquee-row">
                <div className={`logo-marquee-track ${row.dirClass}`}>
                  {[...row.items, ...row.items].map((filename, i) => (
                    <div key={`customer-${rowIdx}-${filename}-${i}`} className="customer-logo-item">
                      <img src={`${baseUrl}/img/customers-logo/${encodeURIComponent(filename)}`} alt="Customer logo" loading="lazy" />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function HomePartnersSection() {
  return (
    <section className="home-section home-section--wide animate-on-scroll">
      <div className="container">
        <HomeSectionHead label="Technology Partners" title="Authorized Partners" />
        <div className="home-logo-marquee-wrap">
          <div className="logo-marquee logo-marquee-partners home-partners-logos">
            {[
              { items: partnerRowOne, dirClass: "is-ltr" },
              { items: partnerRowTwo, dirClass: "is-rtl" },
            ].map((row, rowIdx) => (
              <div key={`partner-row-${rowIdx}`} className="logo-marquee-row">
                <div className={`logo-marquee-track ${row.dirClass}`}>
                  {[...row.items, ...row.items].map((logo, i) => (
                    <div key={`partner-${rowIdx}-${logo.folder}-${logo.file}-${i}`} className="partner-logo-item">
                      <img
                        src={`${baseUrl}/img/${logo.folder}/${encodeURIComponent(logo.file)}`}
                        alt=""
                        loading="lazy"
                        onError={(e) => { e.target.style.display = "none"; e.target.nextElementSibling?.classList.remove("d-none"); }}
                      />
                      <span className="d-none">Partner</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
